export interface SubscriptionRequest {
  subscribeType: SubscriptionCategory;
  source: string;
  entityPath: string;
  entityName: string;
}

export enum SubscriptionCategory {
  Legislation = "Legislation",
  WorkspaceDocument = "WorkspaceDocument",
  Workspace = "Workspace",
  Conversation = "Conversation",
}
export interface Subscription {
  id: string;
  source: string;
  entityPath: string;
  entityType: SubscriptionCategory;
  entityName: string;
}
